import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import {
  isEligibleForCompanyPurchase,
  isEligibleForCompanyTrial,
  isEligibleForTeamPurchase,
  isEligibleForTeamTrial,
} from '../isEligible';
import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';

type Output = {
  error?: string;
  isEligibleForCompanyPurchase: boolean;
  isEligibleForCompanyTrial: boolean;
  isEligibleForTeamPurchase: boolean;
  isEligibleForTeamTrial: boolean;
  isLoading: boolean;
};

export const eligibilityQuery = gql`
  query eligibilityQuery($accountId: Int!) {
    account(id: $accountId) {
      companiesTrialEndDate
      companyAccountEndDate
      currentUserRole
      hasBeenInCompaniesTrial
      id
      isTrialingTeams
      isTrialingCompanies
      plan: planV2 {
        allowCompanies
        hasTeams
        id
        type
      }
      teamAccountEndDate
      teamTrialEndDate
    }
  }
`;

export const useEligibility = (): Output => {
  const { accountId } = useCurrentAccountId();
  const { data, error, loading } = useQuery(eligibilityQuery, {
    fetchPolicy: 'network-only',
    skip: !accountId,
    variables: { accountId },
  });

  const accounts = data?.account ? [data.account] : [];

  return {
    error: error ? 'Error loading eligibility information.' : undefined,
    isEligibleForCompanyPurchase: isEligibleForCompanyPurchase(accounts),
    isEligibleForCompanyTrial: isEligibleForCompanyTrial(accounts),
    isEligibleForTeamPurchase: isEligibleForTeamPurchase(accounts),
    isEligibleForTeamTrial: isEligibleForTeamTrial(accounts),
    isLoading: loading,
  };
};
